<template>
  <svg
    class="sidebar-icon"
    :class="[`si-${size}`, `si-tone-${tone}`]"
    :width="px"
    :height="px"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <!-- dashboard -->
    <g v-if="name === 'dashboard'">
      <rect x="2.5" y="3" width="15" height="14" rx="2" stroke="currentColor" stroke-width="1.4"/>
      <path d="M5.5 14V10.5M10 14V7.5M14.5 14V9.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- customer -->
    <g v-else-if="name === 'customer'">
      <circle cx="10" cy="7" r="2.8" stroke="currentColor" stroke-width="1.4"/>
      <path d="M4.5 16.5c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- target -->
    <g v-else-if="name === 'target'">
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>
      <circle cx="10" cy="10" r="2.5" fill="currentColor"/>
    </g>
    <!-- quote -->
    <g v-else-if="name === 'quote'">
      <path d="M5 5h10v10H5V5z" stroke="currentColor" stroke-width="1.4" rx="1"/>
      <path d="M7.5 8h5M7.5 10.5h3.5M7.5 13h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- contract -->
    <g v-else-if="name === 'contract'">
      <path d="M6 3.5h8a1 1 0 011 1v11a1 1 0 01-1 1H6a1 1 0 01-1-1v-11a1 1 0 011-1z" stroke="currentColor" stroke-width="1.4"/>
      <path d="M7.5 7h5M7.5 10h5M7.5 13h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- agent -->
    <g v-else-if="name === 'agent' || name === 'agent-chart'">
      <path d="M4 10h5l2-3 2 6 2-4h3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <!-- flag -->
    <g v-else-if="name === 'flag'">
      <path d="M5 4v12M5 4h8l-2 3 2 3H5" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
    </g>
    <!-- trophy -->
    <g v-else-if="name === 'trophy'">
      <path d="M6 4h8v3a4 4 0 01-8 0V4z" stroke="currentColor" stroke-width="1.4"/>
      <path d="M8 14h4M10 11v3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <path d="M6 4H4.5a1.5 1.5 0 000 3H6M14 4h1.5a1.5 1.5 0 010 3H14" stroke="currentColor" stroke-width="1.3"/>
    </g>
    <!-- box -->
    <g v-else-if="name === 'box'">
      <path d="M3.5 6.5L10 3l6.5 3.5V14L10 17.5 3.5 14V6.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M10 3v14M3.5 6.5l6.5 3.5 6.5-3.5" stroke="currentColor" stroke-width="1.3"/>
    </g>
    <!-- warehouse -->
    <g v-else-if="name === 'warehouse'">
      <path d="M3 8.5L10 4l7 4.5V16H3V8.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M7.5 16v-4h5v4" stroke="currentColor" stroke-width="1.3"/>
    </g>
    <!-- folder -->
    <g v-else-if="name === 'folder'">
      <path d="M4 6.5a1 1 0 011-1h3l1.5 1.5H15a1 1 0 011 1V15a1 1 0 01-1 1H5a1 1 0 01-1-1V6.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
    </g>
    <!-- truck -->
    <g v-else-if="name === 'truck'">
      <path d="M3 13h11V7H3v6z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M14 9h2l1.5 2.5V13h-3.5V9z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <circle cx="6" cy="14" r="1.2" fill="currentColor"/>
      <circle cx="14.5" cy="14" r="1.2" fill="currentColor"/>
    </g>
    <!-- check -->
    <g v-else-if="name === 'check'">
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M7 10l2 2 4-4.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <!-- receipt -->
    <g v-else-if="name === 'receipt'">
      <path d="M6 3.5h8v13l-1.5-1-1.5 1-1.5-1-1.5 1-1.5-1L6 16.5V3.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M8 7h4M8 10h4M8 13h2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- money-in -->
    <g v-else-if="name === 'money-in'">
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M10 6.5v7M7.5 12.5h5a1.5 1.5 0 000-3h-3a1.5 1.5 0 010-3h5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- wallet -->
    <g v-else-if="name === 'wallet'">
      <rect x="3" y="5.5" width="14" height="9" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M3 8.5h14M14 11.5h1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- expense -->
    <g v-else-if="name === 'expense'">
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M7 10h6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- payable -->
    <g v-else-if="name === 'payable'">
      <rect x="3.5" y="5" width="13" height="10" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M3.5 8.5h13M6.5 12h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- calculator -->
    <g v-else-if="name === 'calculator'">
      <rect x="4.5" y="3.5" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M6.5 6.5h7M6.5 9.5h2M9.5 9.5h2M12.5 9.5h0.01M6.5 12h2M9.5 12h2M12.5 12h0.01" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </g>
    <!-- droplet -->
    <g v-else-if="name === 'droplet'">
      <path d="M10 4c2.5 3.5 5 6 5 8.5a5 5 0 11-10 0C5 10 7.5 7.5 10 4z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
    </g>
    <!-- trend -->
    <g v-else-if="name === 'trend-up'">
      <path d="M4 14l4-4 3 3 5-6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13 7h2.5v2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <g v-else-if="name === 'trend-down'">
      <path d="M4 6l4 4 3-3 5 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <!-- map -->
    <g v-else-if="name === 'map'">
      <path d="M4 5l4-1.5 4 1.5 4-1.5v11l-4 1.5-4-1.5-4 1.5V5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M8 3.5v11M12 5v11" stroke="currentColor" stroke-width="1.3"/>
    </g>
    <!-- user -->
    <g v-else-if="name === 'user'">
      <circle cx="10" cy="7" r="2.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M5 16c0-2.8 2.2-5 5-5s5 2.2 5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- report -->
    <g v-else-if="name === 'report'">
      <path d="M5 3.5h10v13H5V3.5z" stroke="currentColor" stroke-width="1.4"/>
      <path d="M7.5 7h5M7.5 10h5M7.5 13h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- forecast -->
    <g v-else-if="name === 'forecast'">
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M10 6v4l2.5 2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- bell -->
    <g v-else-if="name === 'bell'">
      <path d="M10 4a3.5 3.5 0 013.5 3.5v2.5l1 2H5.5l1-2V7.5A3.5 3.5 0 0110 4z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M8.5 15a1.5 1.5 0 003 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- rules -->
    <g v-else-if="name === 'rules'">
      <path d="M5 4h10M5 8h7M5 12h10M5 16h6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <circle cx="15" cy="12" r="1.2" fill="currentColor"/>
    </g>
    <!-- role -->
    <g v-else-if="name === 'role'">
      <rect x="4" y="4" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.4"/>
      <circle cx="10" cy="9" r="2" stroke="currentColor" stroke-width="1.2"/>
      <path d="M7 14c.8-1.5 2-2.2 3-2.2s2.2.7 3 2.2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </g>
    <!-- key -->
    <g v-else-if="name === 'key'">
      <circle cx="8" cy="12" r="3" stroke="currentColor" stroke-width="1.4"/>
      <path d="M10.5 9.5L16 4M14 4h2v2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <!-- lock -->
    <g v-else-if="name === 'lock'">
      <rect x="5.5" y="9" width="9" height="7" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M7 9V7a3 3 0 016 0v2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </g>
    <!-- settings -->
    <g v-else-if="name === 'settings'">
      <circle cx="10" cy="10" r="2.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M10 3v1.5M10 15.5V17M3 10h1.5M15.5 10H17M5.05 5.05l1.06 1.06M13.9 13.9l1.06 1.06M5.05 14.95l1.06-1.06M13.9 6.1l1.06-1.06" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </g>
    <!-- doc fallback -->
    <g v-else>
      <path d="M5.5 3.5h6l3 3v10a1 1 0 01-1 1H5.5a1 1 0 01-1-1v-12a1 1 0 011-1z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
      <path d="M11.5 3.5V7H15" stroke="currentColor" stroke-width="1.3"/>
    </g>
  </svg>
</template>

<script>
const SIZE_MAP = { sm: 14, md: 18, lg: 22 }

export default {
  name: 'SidebarIcon',
  props: {
    name: { type: String, default: 'doc' },
    size: { type: String, default: 'md' },
    tone: { type: String, default: 'white' }
  },
  computed: {
    px() {
      return SIZE_MAP[this.size] || 18
    }
  }
}
</script>

<style scoped>
.sidebar-icon { display: block; flex-shrink: 0; }
.si-tone-white { color: #fff; }
.si-tone-sub { color: #6b7280; }
.si-tone-color { color: #2563eb; }
.erp-sub-link.active .si-tone-sub { color: #2563eb; }
</style>
